const NotPurchasedAddon = () => {
    let text = gettext("Cannot be purchased individually");
    return(
        <p>{text}</p>
    )
}

export default NotPurchasedAddon;